import React, { useEffect } from 'react';

const OfflinePage = () => {
  useEffect(() => {
    const handleOnline = () => {
      window.location.href = '/';
    };

    window.addEventListener('online', handleOnline);
    return () => window.removeEventListener('online', handleOnline);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center h-screen text-center bg-gray-50 text-gray-800 font-roboto w-full">
      <img src="/assets/images/logos/surevue.svg" alt="SureVue Logo" className="w-[560px] mb-5" />
      <h1 className="text-3xl mb-2">You're Offline</h1>
      <p className="text-base text-gray-600 mb-8">
        It looks like you're not connected to the internet.<br />
        Please check your connection and try again.
      </p>
      <a 
        href="/" 
        className="inline-block px-10 py-5 bg-blue-500 text-white no-underline rounded"
        onClick={(e) => {
          if (!navigator.onLine) {
            e.preventDefault();
          }
        }}
      >
        Retry
      </a>
    </div>
  );
};

export default OfflinePage;